import { ExternalLink, Plus, ThumbsUp, X } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { XStack, YStack } from "tamagui";
import { Body } from "../ui/Body";
import { Box } from "../ui/Box";
import { Button } from "../ui/Button";
import { Subtext } from "../ui/Subtext";
import { getStringInLS, saveStringInLS } from "./localStorage";
import { isRunningInApp } from "./utils";

const appStoreUrl = "https://apps.apple.com/us/app/planira/id6670337778";
const playStoreUrl =
  "https://play.google.com/store/apps/details?id=se.bloop.planira";

const openApp = (planUid?: string) => {
  const _isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const schemeUrl = `planira://?planUid=${planUid}`;

  // Try to open the app with a custom URL scheme
  window.location.href = schemeUrl;
};

const redirect = () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  if (isIOS) {
    window.location.href = appStoreUrl; // Redirect to App Store
  } else {
    window.location.href = playStoreUrl; // Redirect to Google Play
  }
};

export const OpenInAppBox: React.FC<{ planUid: string }> = observer(
  ({ planUid }) => {
    const LS_KEY = `hide-app-box-${planUid}`;

    const [showOpenInApp, setShowOpenInApp] = React.useState(false);

    React.useEffect(() => {
      const hiddenInLs = getStringInLS(LS_KEY);

      if (hiddenInLs) {
        return;
      }

      const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) &&
        // @ts-expect-error
        !window.MSStream;

      const isAndroid = /Android/.test(navigator.userAgent);
      const isMobile = isIOS || isAndroid;

      if (!isRunningInApp() && isMobile) {
        setShowOpenInApp(true);
      }
    }, [LS_KEY]);

    if (!showOpenInApp) {
      return null;
    }

    return (
      <Box>
        <YStack gap="$medium" justifyContent={"space-between"}>
          <YStack gap="$small">
            <XStack gap="$medium" alignItems={"center"}>
              <ExternalLink />
              <Body>Use the App</Body>
            </XStack>
            <Subtext>Receive notifications!</Subtext>
          </YStack>

          <XStack gap="$medium">
            <Button
              icon={ThumbsUp}
              type="primary"
              style={{ flex: 1 }}
              onPress={() => openApp(planUid)}
            >
              Open
            </Button>

            <Button
              icon={Plus}
              type="secondary"
              style={{ flex: 1 }}
              onPress={() => redirect()}
            >
              Install
            </Button>
          </XStack>
        </YStack>

        <Button
          type={"ghost"}
          icon={X}
          onPress={() => {
            saveStringInLS(LS_KEY, "true");
            setShowOpenInApp(false);
          }}
          position={"absolute"}
          top={0}
          right={0}
        />
      </Box>
    );
  },
);
